import { useMessageThreadRead } from "../../hooks/api/v2/message/useMessageThreadRead";
import { RelationshipComments } from "../../components/comments/RelationshipComments";
import { useRelationshipCommentCreate } from "../../hooks/api/v2/relationshipComments/useRelationshipCommentCreate";
import { useMessageConversation } from "../../hooks/api/v2/message/useMessageConversation";

export const MessageThread = ({
  relationshipId,
  flaggedAsBadPayer,
  className,
}: {
  relationshipId: number;
  flaggedAsBadPayer?: boolean;
  className?: string;
}) => {
  const conversationQuery = useMessageConversation(relationshipId);
  const mutation = useRelationshipCommentCreate();
  useMessageThreadRead(
    relationshipId,
    conversationQuery.isError
      ? null
      : (conversationQuery.data?.readCursor ?? null),
  );

  return (
    <RelationshipComments
      relationshipId={relationshipId}
      mutation={mutation}
      commentsQuery={conversationQuery}
      className={className}
      flaggedAsBadPayer={flaggedAsBadPayer}
    />
  );
};
